import {ajax_get, ajax_post} from "./index";

// 登录
export const postLogin = (data) => ajax_get('/login', data);
//校验token接口
export const fixToken = (data) => ajax_post('/getsid', data);

//获取验证码
export const getnum = (data) => ajax_get('/sendvcode', data);
//短信验证码登录
export const loginPhone = (data) => ajax_get('/mobileset', data);
//登出
export const loginout = (data) => ajax_get('/logout', data);

//查询角色类型
export const selecttype = (data) => ajax_get('/clerkchoice', data);

//保存数据
export const savedata = (data) => ajax_post('/museumscoresave', data);

//保存特殊加分项
export const savedataspecial = (data) => ajax_post('/museumspecialfillsave', data);
//提交数据
export const submitdata = (data) => ajax_get('/museumfillsub', data);

//撤销数据
export const resetdata = (data) => ajax_get('/museumfillsubundo', data);

//查询首页数据
export const selectIndex = (data) => ajax_get('/home', data);

export const selectIndexAll = (data) => ajax_get('/museumscorequery', data);

//保存基本信息
export const savebasedata = (data) => ajax_post('/museuminfosave', data);
export const saveitemdata = (data) => ajax_post('/museumitemsave', data);
export const scodeLibrary = (data) => ajax_get('/museumqryregion', data);

//注册用户
export const registerUser = (data) => ajax_get('/museumreg', data);
export const museumnamecheck = (data) => ajax_get('/museumnamecheck', data);
export const museumvote = (data) => ajax_get('/museumvote', data);